import api from './api'; // Import Axios instance

export const createUser = async (userData) => {
    try {
        const response = await api.post('/user/register', userData);
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error.payload);
        throw error;
    }
};

export const searchUser = async (userData) => {
    try {
        const response = await api.get(`/user/email/${userData.userEmail}`);
        return response.data.payload;
    } catch (error) {
        console.error('Error creating user:', error.payload);
        throw error;
    }
};

export const updateUserRoles = async (userData) => {
    try {
        const response = await api.patch(`/user/roles/`, userData);
        return response;
    } catch (error) {
        console.error('Error updating user roles:', error);
        throw error;
    }
};
